var _defs, _polygon, _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplorerGroundSurfaceSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aeaeb6;}.cls-2{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ExplorerGroundSurface_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.09 18.23 25.65 20 16 24.79 6.35 20 9.91 18.23 7.66 17.12 1.84 20 16 27.02 30.16 20 24.34 17.12 22.09 18.23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.72,11.29a17.29,17.29,0,0,1-10,.27,20.86,20.86,0,0,1-2.4-1C15.18,10,14.54,9.77,14,10s-.6.5-.93,1.37a5.9,5.9,0,0,1-1.84,2.85,6.16,6.16,0,0,1-2.64,1.13l2.12,1c2.32-2.23,4.5-3.27,6.49-3.07a8,8,0,0,1,2.46.77,7.82,7.82,0,0,0,3.39.85h0a7.53,7.53,0,0,0,1.56-.17L30.16,12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.82,15.91A6.41,6.41,0,0,0,17,15.3c-1.26-.12-2.73.56-4.38,2L16,19l4.79-2.38A12.62,12.62,0,0,1,18.82,15.91Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.94,12.63a4.13,4.13,0,0,0,1.22-2A3.69,3.69,0,0,1,13.28,8.1c1.37-.5,2.61.07,3.91.67a19.12,19.12,0,0,0,2.17.88,13.85,13.85,0,0,0,6.56.25L16,5,1.84,12l2.77,1.37C7.09,13.72,8.88,13.47,9.94,12.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorerGroundSurfaceSvg);
export default __webpack_public_path__ + "static/media/ExplorerGroundSurface_svg.85edd77d55ef5ec540961e7768b3ab4b.svg";
export { ForwardRef as ReactComponent };